module.exports = __webpack_public_path__ + "img/ZoftConnect_Logo_Black_for_Bill_150px.2cafe780.png";